module.exports = __webpack_public_path__ + "img/Recurso 25@300x.402c32d4.png";